/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputGeoTraceCorridor
 */
export interface OutputGeoTraceCorridor {
    /**
     * 
     * @type {number}
     * @memberof OutputGeoTraceCorridor
     */
    aLat?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputGeoTraceCorridor
     */
    aLon?: number;
    /**
     * 
     * @type {boolean}
     * @memberof OutputGeoTraceCorridor
     */
    active?: boolean;
    /**
     * 
     * @type {number}
     * @memberof OutputGeoTraceCorridor
     */
    anchorLat?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputGeoTraceCorridor
     */
    anchorLon?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputGeoTraceCorridor
     */
    bLat?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputGeoTraceCorridor
     */
    bLon?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputGeoTraceCorridor
     */
    slackKm?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputGeoTraceCorridor
     */
    spanKm?: number;
}

/**
 * Check if a given object implements the OutputGeoTraceCorridor interface.
 */
export function instanceOfOutputGeoTraceCorridor(value: object): boolean {
    return true;
}

export function OutputGeoTraceCorridorFromJSON(json: any): OutputGeoTraceCorridor {
    return OutputGeoTraceCorridorFromJSONTyped(json, false);
}

export function OutputGeoTraceCorridorFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputGeoTraceCorridor {
    if (json == null) {
        return json;
    }
    return {
        
        'aLat': json['aLat'] == null ? undefined : json['aLat'],
        'aLon': json['aLon'] == null ? undefined : json['aLon'],
        'active': json['active'] == null ? undefined : json['active'],
        'anchorLat': json['anchorLat'] == null ? undefined : json['anchorLat'],
        'anchorLon': json['anchorLon'] == null ? undefined : json['anchorLon'],
        'bLat': json['bLat'] == null ? undefined : json['bLat'],
        'bLon': json['bLon'] == null ? undefined : json['bLon'],
        'slackKm': json['slackKm'] == null ? undefined : json['slackKm'],
        'spanKm': json['spanKm'] == null ? undefined : json['spanKm'],
    };
}

export function OutputGeoTraceCorridorToJSON(value?: OutputGeoTraceCorridor | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'aLat': value['aLat'],
        'aLon': value['aLon'],
        'active': value['active'],
        'anchorLat': value['anchorLat'],
        'anchorLon': value['anchorLon'],
        'bLat': value['bLat'],
        'bLon': value['bLon'],
        'slackKm': value['slackKm'],
        'spanKm': value['spanKm'],
    };
}

